import map from 'ramda/src/map';
import pick from 'ramda/src/pick';
import pipe from 'ramda/src/pipe';
import propOr from 'ramda/src/propOr';
import { createSelector } from 'reselect';
import {
  getAll,
} from '../../barbers/selector';
import {
  parseCustomerBookingInterval,
  parseMultiFieldValues,
} from '../../../common/helpers/times';
import { fullName } from '../../../common/helpers/users';
import { activeShop } from '../../../auth/selectors';

const pickValues = pick([
  'bookNoPay',
  'tipEnabled',
  'earlyTipping',
  'lateTipping',
  'canCustomerCancel',
  'allowMultipleServices',
  'bookingInterval',
  'minServiceLen',
  'advanceBookDays',
  'advanceBookMins',
  'advanceCancelMins',
  'customerReminder',
  'name',
  'id',
  'useServiceDurationForTimes',
]);

const assignName = barber => ({
  ...barber,
  name: fullName(barber, true),
});

const assignShopName = shop => ({
  ...shop,
  name: 'Shop',
});

const assignCustomerInterval = data => ({
  ...data,
  minServiceLen: parseCustomerBookingInterval(data),
});

const prepareShop = pipe(assignShopName, pickValues, parseMultiFieldValues, assignCustomerInterval);
const prepareBarber = pipe(assignName, pickValues, parseMultiFieldValues, assignCustomerInterval);
const combineData = (barbers, shop) => ({
  barbers: map(prepareBarber, barbers),
  shops: [prepareShop(shop)],
});

export const getInitialValues = createSelector(
  getAll,
  activeShop,
  combineData,
);

export const getShopBookNoPay = pipe(activeShop, propOr(false, 'bookNoPay'));
